import { createRouter, createWebHistory } from "vue-router";
import Contact from "../views/Contact.vue";
import About from "../views/AboutUs.vue";
import FAQ from "../views/FAQ.vue";
import Services from "../views/Services.vue";
import Home2 from "../views/Home2.vue";

const routes = [
  {
    path: "/",
    name: "Home2",
    component: Home2,
    meta: {
      title: "Afino Tax Consultants | Corporate Tax, VAT & Accounting Services in Dubai, UAE",
      description: "Trusted tax and accounting firm in Dubai, UAE. Expert Corporate Tax, VAT, Accounting, and Business Advisory services. Your Partner in Compliance & Financial Growth.",
      keywords: "tax consultants Dubai, corporate tax UAE, VAT services Dubai, accounting services Dubai, tax advisor Dubai, bookkeeping Dubai, business advisory UAE, tax compliance Dubai, FTA compliance, tax registration UAE",
      ogTitle: "Afino Tax Consultants | Corporate Tax, VAT & Accounting Services in Dubai, UAE",
      ogDescription: "Trusted tax and accounting firm in Dubai, UAE. Expert Corporate Tax, VAT, Accounting, and Business Advisory services.",
      ogImage: "/assets/img/logo.png",
      ogUrl: "https://www.afinotax.com/",
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      title: "Contact Us | Afino Tax Consultants Dubai, UAE",
      description: "Get in touch with Afino Tax Consultants in Dubai, UAE. Expert tax and accounting services. Call +971 54 566 8994 or email sales@afinotax.com",
      keywords: "contact tax consultant Dubai, tax advisor contact UAE, accounting services Dubai contact, tax consultant phone Dubai, tax consultant email UAE",
      ogTitle: "Contact Us | Afino Tax Consultants Dubai, UAE",
      ogDescription: "Get in touch with Afino Tax Consultants in Dubai, UAE. Expert tax and accounting services.",
      ogImage: "/assets/img/logo.png",
      ogUrl: "https://www.afinotax.com/contact",
    },
  },
  {
    path: "/about-us",
    name: "About",
    component: About,
    meta: {
      title: "About Us | Afino Tax Consultants - Trusted Tax & Accounting Firm Dubai",
      description: "Learn about Afino Tax Consultants, a trusted tax and accounting firm in Dubai, UAE. Our mission, vision, and values. Expert professionals with international qualifications.",
      keywords: "about tax consultant Dubai, tax accounting firm Dubai, tax consultant team UAE, tax advisor qualifications Dubai, accounting firm history UAE",
      ogTitle: "About Us | Afino Tax Consultants - Trusted Tax & Accounting Firm Dubai",
      ogDescription: "Learn about Afino Tax Consultants, a trusted tax and accounting firm in Dubai, UAE. Our mission, vision, and values.",
      ogImage: "/assets/img/logo.png",
      ogUrl: "https://www.afinotax.com/about-us",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: FAQ,
    meta: {
      title: "Frequently Asked Questions | Afino Tax Consultants Dubai",
      description: "Find answers to common questions about Corporate Tax, VAT, Accounting, and Business Advisory services in Dubai, UAE. Expert tax consultant FAQs.",
      keywords: "tax consultant FAQ Dubai, VAT questions UAE, corporate tax FAQ Dubai, accounting services questions UAE, tax compliance FAQ Dubai",
      ogTitle: "Frequently Asked Questions | Afino Tax Consultants Dubai",
      ogDescription: "Find answers to common questions about Corporate Tax, VAT, Accounting, and Business Advisory services in Dubai, UAE.",
      ogImage: "/assets/img/logo.png",
      ogUrl: "https://www.afinotax.com/faq",
    },
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    meta: {
      title: "Our Services | Corporate Tax, VAT & Accounting Services Dubai, UAE",
      description: "Comprehensive tax and accounting services in Dubai, UAE. Corporate Tax, VAT, Accounting, Bookkeeping, Audit Support, Business Setup, ESR, AML & KYC Compliance.",
      keywords: "corporate tax services Dubai, VAT services UAE, accounting services Dubai, bookkeeping Dubai, audit support UAE, business setup Dubai, ESR compliance UAE, AML KYC compliance Dubai",
      ogTitle: "Our Services | Corporate Tax, VAT & Accounting Services Dubai, UAE",
      ogDescription: "Comprehensive tax and accounting services in Dubai, UAE. Corporate Tax, VAT, Accounting, Bookkeeping, Audit Support, and more.",
      ogImage: "/assets/img/logo.png",
      ogUrl: "https://www.afinotax.com/services",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Update meta tags on route change
router.beforeEach((to, from, next) => {
  // Update document title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // Update meta tags
  const updateMetaTag = (name, content, attribute = 'name') => {
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  // Update primary meta tags
  if (to.meta.title) {
    updateMetaTag('title', to.meta.title);
  }
  if (to.meta.description) {
    updateMetaTag('description', to.meta.description);
  }
  if (to.meta.keywords) {
    updateMetaTag('keywords', to.meta.keywords);
  }

  // Update Open Graph tags
  if (to.meta.ogTitle) {
    updateMetaTag('og:title', to.meta.ogTitle, 'property');
  }
  if (to.meta.ogDescription) {
    updateMetaTag('og:description', to.meta.ogDescription, 'property');
  }
  if (to.meta.ogImage) {
    updateMetaTag('og:image', to.meta.ogImage, 'property');
  }
  if (to.meta.ogUrl) {
    updateMetaTag('og:url', to.meta.ogUrl, 'property');
  }

  // Update Twitter Card tags
  if (to.meta.ogTitle) {
    updateMetaTag('twitter:title', to.meta.ogTitle, 'property');
  }
  if (to.meta.ogDescription) {
    updateMetaTag('twitter:description', to.meta.ogDescription, 'property');
  }
  if (to.meta.ogImage) {
    updateMetaTag('twitter:image', to.meta.ogImage, 'property');
  }

  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  if (to.meta.ogUrl) {
    canonical.setAttribute('href', to.meta.ogUrl);
  } else {
    canonical.setAttribute('href', window.location.origin + to.path);
  }

  next();
});

export default router;
